import React, { Fragment } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from 'next/components/ui';
import { PointShape } from './shape';

const Wrapper = styled.div`
  background-color: var(--white);
  border-radius: 6px;
  box-shadow: var(--level-3);
  font-size: var(--x-small);
  pointer-events: auto;
  width: 320px;
`;

const Title = styled.div`
  background-color: var(--noreaster);
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  color: var(--pleather);
  font-weight: var(--bold);
  padding: 8px 24px;
`;

const Points = styled.div`
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: 16px 1fr auto;
  padding: 12px 24px;
`;

const Marker = styled(Icon)`
  color: ${({ color }) => color};
  font-size: 8px;
`;

const Name = styled.span``;

const Value = styled.span`
  font-weight: var(--bold);
`;

const date = timestamp => new Intl.DateTimeFormat().format(timestamp);
const number = value => new Intl.NumberFormat().format(value);

export default function ChartTooltip({ points, x }) {
  // Use label of first point or fallback to date format of x value
  const title = points[0]?.point?.label ?? date(x);

  return (
    <Wrapper>
      <Title>{title}</Title>
      <Points>
        {points.map(
          ({ color, series: { name }, point: { value } = {}, ...point }) => (
            <Fragment key={point.x}>
              <Marker color={color} icon="circle" />
              <Name>{name}</Name>
              <Value>{value ?? number(point.y)}</Value>
            </Fragment>
          )
        )}
      </Points>
    </Wrapper>
  );
}

ChartTooltip.propTypes = {
  points: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      point: PointShape,
      series: PropTypes.shape({
        name: PropTypes.string,
      }),
      x: PropTypes.number,
      y: PropTypes.number,
    })
  ),
  x: PropTypes.number,
};

export function formatter() {
  const { points, x } = this;
  return renderToStaticMarkup(<ChartTooltip points={points} x={x} />);
}
